export default "__VITE_ASSET__BwpEdUYD__"